import React, { Fragment } from "react";

import Overlay from "./Overlay";
import LockButton from "./Buttons/LockButton";
import { StyledToolbar, TileToolbarTitle } from "./ToolbarStyles";

export default function Toolbar({ chart, isMinimized, isFullScreen, mode }) {
  const intervalName =
    chart.interval === 15
      ? "15m"
      : chart.interval === 60
      ? "1h"
      : chart.interval === 240
      ? "4h"
      : chart.interval === 1440
      ? "1D"
      : chart.interval;

  return (
    <>
      <Overlay />
      <StyledToolbar>
        <TileToolbarTitle textLeft={isMinimized}>
          {chart.chartName} {intervalName}
        </TileToolbarTitle>
      </StyledToolbar>
      {mode !== "heat_map" && (
        <Fragment>
          {!isMinimized && !isFullScreen && (
            <LockButton chartId={chart.chartId} />
          )}
        </Fragment>
      )}
    </>
  );
}
